import { render, staticRenderFns } from "./OnboardingContinue.vue?vue&type=template&id=29f6adb3&scoped=true&"
import script from "./OnboardingContinue.vue?vue&type=script&lang=js&"
export * from "./OnboardingContinue.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingContinue.vue?vue&type=style&index=0&id=29f6adb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f6adb3",
  null
  
)

export default component.exports